import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AuthService } from '../../../auth/service/auth.service';

@Component({
    selector: 'app-admin-menu',
    template: `
    <!-- Admin Menu Button -->
    <button
      *ngIf="authService.$isAdmin | async"
      #adminMenuTrigger="matMenuTrigger"
      [matMenuTriggerFor]="adminMenu"
      (click)="$event.stopPropagation()"
      class="tw-rounded-md tw-text-sm tw-text-gray-300 tw-border tw-border-solid tw-border-gray-500 tw-h-7"
      aria-label="Admin options">
      <mat-icon class="tw-text-[20px] tw-leading-[24px]">construction</mat-icon>
    </button>

    <!-- Admin Menu -->
    <mat-menu #adminMenu="matMenu" class="tw-mt-2">
      <button mat-menu-item (click)="copyToOrg.emit($event)">
        <mat-icon>content_copy</mat-icon>
        <span>Copy to Organization</span>
      </button>

      <button mat-menu-item (click)="toggleScope.emit($event)">
        <mat-icon>{{ scopeToggleIcon }}</mat-icon>
        <span>{{ scopeToggleText }}</span>
      </button>
    </mat-menu>
  `,
    styleUrls: [],
    standalone: false
})
export class AdminMenuComponent {
  @Input() scopeToggleText: string = 'Make Public';
  @Input() scopeToggleIcon: string = 'public';
  
  @Output() copyToOrg = new EventEmitter<Event>();
  @Output() toggleScope = new EventEmitter<Event>();

  constructor(protected authService: AuthService) {}
}